import { Component } from '@angular/core';
import { IMPORTS } from './_imports';

@Component({
    selector: 'shell-embed',
    templateUrl: './shell-embed.component.html',
    standalone: true,
    imports: IMPORTS
})
export class ShellEmbedComponent {
    constructor() { }

    hasEDocsApiTimeoutError(): boolean {
        return window.localStorage.getItem('thhet') == '1';
    }

    onClose() {
        if (window.localStorage.getItem('thhet') == '1') {
            window.localStorage.setItem('thhet', '0');
            window.location.reload();
        } else {
            window.localStorage.setItem('thhet', '0');
        }
    }

    // #region [===== private methods =====]
    // #endregion
}
